import {Document, Page, pdfjs} from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

export default function PublicPdfViewer({preview}) {
    return (
        <Document file={preview}>
            <Page pageNumber={1} className="page" width={140}/>
        </Document>
    );
}